import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectError = createSelector(
  [(store: RootState) => store.userAuthentication.error],
  (error) => error
);
